import React, { Component } from 'react'
import Popover from 'react-popover'
import uniqueId from 'lodash/uniqueId'
import { withTranslation } from 'react-i18next'

import Fire from 'app/components/SVGS/Fire'
import DropShadowFilter from 'app/components/SVGS/DropShadowFilter'
import BaseGraphLine from '../BaseGraphLine'

class StreakLine extends Component {
  state = {
    showTooltip: false,
  }
  render() {
    const { props, state } = this
    const { t, activitiesCompleted, isLast, coordinates } = props
    const circle = {
      x: coordinates && coordinates.x2,
      y: coordinates && coordinates.y2,
      r: 10,
    }
    const gradientId = uniqueId('last-completed')
    const lastX = circle.x - circle.r + 1
    return (
      <g>
        <BaseGraphLine
          {...coordinates}
          strokeDasharray="0"
          strokeLinecap="round"
          style={{
            stroke: state.showTooltip ? '#ffa70f' : '#ffbe4e',
            strokeWidth: 2,
          }}
        />
        <Popover
          isOpen={this.state.showTooltip}
          preferPlace={'right'}
          onOuterAction={() => this.setState({ showTooltip: false })}
          body={
            <div style={{ padding: '8px 16px', color: '#647180', fontSize: '14px' }}>
              {t('activities-completed-streak', { activitiesCompleted })}
            </div>
          }
        >
          <g
            onMouseEnter={() => {
              this.setState({ showTooltip: true })
            }}
            onMouseLeave={() => {
              this.setState({ showTooltip: false })
            }}
          >
            <circle
              cx={!isLast ? circle.x : lastX}
              cy={circle.y}
              r={circle.r}
              fill={!isLast ? '#fff' : `url(#${gradientId})`}
              filter={`url(#${DropShadowFilter.filterID})`}
              style={{ cursor: 'pointer' }}
            />
            <defs>
              <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#FF7F00' }} />
                <stop offset="100%" style={{ stopColor: '#FFAB00' }} />
              </linearGradient>
            </defs>
            <Fire
              lastCompleted={isLast}
              svgProps={{
                width: 8,
                height: 11,
                x: (!isLast ? circle.x : lastX) - 4,
                y: circle.y - 6,
              }}
            />
          </g>
        </Popover>
      </g>
    )
  }
}

StreakLine.displayName = 'StreakLine'

export default withTranslation('user')(StreakLine)
